// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2ulau","inner":"Form_inner__3HigX","range":"Form_range__OVl8K","name":"Form_name__11JOL","actions":"Form_actions__2T2qC"};